import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';

export const finTabReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'FIN_TAB_LOADED':
      return fromJS(action.data);
    case 'CLEAR_DEAL':
    case 'DEAL_LOADED':
    case 'LOGOUT':
      return new Map();
    default:
      return state;
  }
};

export const loadFinTab = (dispatch, dealId) => {
  dispatch({ type: 'FIN_TAB_LOADING' });
  return RestAPI.get(`/deals/purchase/api/fintab/${dealId}`)
    .then(
      (data) => {
        dispatch({ type: 'FIN_TAB_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'FIN_TAB_LOAD_FAILED' });
        return true;
      },
    );
};
